import React from "react";
import View from "./View";
import {
  Alert,
  Box,
  Button,
  Container,
  Stack,
  Typography,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { fonts } from "fonts";
import Loader from "components/react-lib/generic-ui/Loader";
import { useTheme } from "@emotion/react";
import { useDocumentDataOnce } from "react-firebase-hooks/firestore";
import { doc } from "firebase/firestore";
import { db } from "firebaseApp";
import { useNavigate, useParams } from "react-router-dom";
import MarkdownBlock from "components/react-lib/markdown-code/MarkdownBlock";
import { popupActions } from "store/react-lib/generic-ui/popup";
import { useAuth } from "context/react-lib/firebase-auth/AuthProvider";

export default function ShareView() {
  const params = useParams();
  const shareId = params.shareId;
  const theme = useTheme();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const auth = useAuth();

  const [share, loading, error] = useDocumentDataOnce(
    shareId ? doc(db, "shares", shareId) : null
  );

  const renderMessage = (content, isContext) =>
    content ? (
      <div
        data-testclass="chat-message-container"
        style={{
          backgroundColor: isContext
            ? theme.palette.conversationBackground.default
            : theme.palette.conversationBackground.active,
          zIndex: 1,
          paddingTop: 20,
          paddingBottom: 10,
          paddingLeft: 16,
          paddingRight: 16,
          borderRadius: 8,
          position: "relative",
          width: "100%",
          boxSizing: "border-box",
          maxWidth: "748px",
        }}
      >
        <MarkdownBlock
          markdownContent={content}
          canCopyCode={true}
          rawTextColor={theme.palette.text.main}
          rawCopyButtonColor={theme.palette.text.main}
          style={{
            color: theme.palette.text.main,
            lineHeight: 1.5,
            fontFamily: fonts.geist,
            overflowX: "auto",
          }}
          onCopy={() => dispatch(popupActions.showSuccess("Copied"))}
        />
      </div>
    ) : null;

  const renderShare = () => {
    if (loading) {
      return <Loader message="Loading shared data" />;
    }
    if (error) {
      console.log(error);
      return <Alert severity="error">Couldn't load shared data.</Alert>;
    }
    if (!share) {
      return <Alert severity="error">Invalid share id.</Alert>;
    }
    return (
      <Stack spacing={2} width="100%">
        <Stack spacing={1}>
          <Typography fontFamily={fonts.anton} color={theme.palette.text.main}>
            Message:
          </Typography>
          {renderMessage(share.context, true)}
        </Stack>
        <Stack spacing={1}>
          <Typography fontFamily={fonts.anton} color={theme.palette.text.main}>
            Answer{share.modelName ? ` from: ${share.modelName}` : ":"}
          </Typography>
          {renderMessage(share.content, false)}
        </Stack>
      </Stack>
    );
  };

  return (
    <View
      renderMenu={false}
      renderLeftActions={() => (
        <Typography
          fontFamily={fonts.anton}
          sx={{
            color: theme.palette.text.main,
          }}
        >
          Shared Message
        </Typography>
      )}
      
    >
      <Container maxWidth="md">
        <Stack
          py={2}
          sx={{
            overflowY: "auto",
            height: "90%",
          }}
        >
          <Stack py={2} spacing={2} alignItems="center" justifyContent="center">
          {(!auth.currentUser) && (
          <Button variant="contained" onClick={() => navigate("/login")}>
            Try CheapGPT
          </Button>
        )}
            {renderShare()}
          </Stack>
        </Stack>
      </Container>
    </View>
  );
}
